import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M27,7.26H21.65V5.91A2.65,2.65,0,0,0,19,3.26H13a2.65,2.65,0,0,0-2.65,2.65V7.26H5a.65.65,0,0,0,0,1.3H6.35V26.09a2.61,2.61,0,0,0,2.56,2.65H23.09a2.61,2.61,0,0,0,2.56-2.65V8.56H27a.65.65,0,0,0,0-1.3ZM11.65,5.91A1.35,1.35,0,0,1,13,4.56h6a1.35,1.35,0,0,1,1.35,1.35V7.26h-8.7Zm12.7,20.18a1.31,1.31,0,0,1-1.26,1.35H8.91a1.31,1.31,0,0,1-1.26-1.35V8.56h16.7Z' }),
  React.createElement('rect', { x: '11.35', y: '12.59', width: '1.3', height: '11' }),
  React.createElement('rect', { x: '15.35', y: '12.59', width: '1.3', height: '11' }),
  React.createElement('rect', { x: '19.35', y: '12.59', width: '1.3', height: '11' })
));